import { css } from "@emotion/react";

export const form = css`
  width: 100%;
`;

export const emailInput = css`
  margin-bottom: 16px;
`;
